import { OverlayContainer } from '@angular/cdk/overlay';
import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, Injector, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, RequestOptions, XHRBackend } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ToastrModule } from 'ngx-toastr';

import { BaseComponent } from './_base/base.component';
import { httpFactory } from './_extensions/http.factory';
import { InterceptorHeader } from './_extensions/interceptor';
import { BlankComponent } from './_layouts/blank/component/blank.component';
import { MainComponent } from './_layouts/main/component/main.component';
import { AcademicYearsService } from './_services';
import { BaseInjector } from './_services/base-injector.service';
import { BaseService } from './_services/base.service';
import { MainFiltersService } from './_services/main-filters.service';
import { AcademicPeriodsService } from './_services/system-settings/academic-periods.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppSettings } from './app.settings';
import { AppErrorHandler } from './errors/app-error-handler';
import { SharedModule } from './shared/shared.module';
import { ConfirmationDialogComponent } from './templates/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './templates/confirmation-dialog/confirmation-dialog.service';
import { TemplatesModule } from './templates/module/templates.module';
import { CustomOverlayContainer } from './templates/utils/custom-overlay-container';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true
};
@NgModule({
  declarations: [AppComponent, MainComponent, BlankComponent, ConfirmationDialogComponent, BaseComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TemplatesModule,
    AppRoutingModule,
    HttpClientModule,
    ModalModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 2500,
      preventDuplicates: true,
      progressBar: true
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    SnotifyModule
  ],
  exports: [BrowserModule, AppRoutingModule, FormsModule, ReactiveFormsModule, DatePipe, ToastrModule],
  providers: [
    AcademicPeriodsService,
    AcademicYearsService,
    AppSettings,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    BaseService,
    { provide: ErrorHandler, useClass: AppErrorHandler },
    DatePipe,
    ConfirmationDialogService,
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    SnotifyService,
    // tslint:disable-next-line: deprecation
    { provide: Http, useFactory: httpFactory, deps: [XHRBackend, RequestOptions] },

    MainFiltersService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorHeader,
      multi: true
    }
  ],
  entryComponents: [ConfirmationDialogComponent],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(translate: TranslateService, private injector: Injector) {
    BaseInjector.injector = this.injector;
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('en');
    translate.use('en');
  }
}
